import api from 'api/api-backend';

/**
 * Activity Logger Utility
 * Centralized function to log user activities across the application
 */

export const logActivity = async (
  action: string,
  entityType: string,
  entityId: string,
  details?: Record<string, unknown>
) => {
  try {
    await api.post('/v1/activities/log', {
      action,
      entity_type: entityType,
      entity_id: entityId.length > 50 ? entityId.substring(0, 50) : entityId,
      details: details || {},
    });
  } catch (error) {
    // Silently fail to not disrupt user experience
    // Log to console in development only
    if (process.env.NODE_ENV === 'development') {
      console.warn('Failed to log activity:', error);
    }
  }
};

/**
 * Predefined action types for consistent tracking
 */
export const ACTIVITY_ACTIONS = {
  // Dashboard
  PROPERTY_SELECTED: 'property_selected',
  VIEW_CHANGED: 'view_changed',

  // Reservation
  BOOKING_CREATED: 'booking_created',
  BOOKING_UPDATED: 'booking_updated',
  CALENDAR_CLICKED: 'calendar_clicked',
  ROOM_BOOKING_CLICKED: 'room_booking_clicked',
  LIST_VIEW_CLICKED: 'list_view_clicked',
  
  // Forecasting / AI Analysis
  ANALYSIS_RUN: 'analysis_run',
  ANALYSIS_V1_EXECUTED: 'analysis_v1_executed',
  ROOM_PRICE_ANALYZED: 'room_price_analyzed',
  PREDICTION_GENERATED: 'prediction_generated',
  
  // Reports
  REPORT_VIEWED: 'report_viewed',
  REPORT_EXPORTED: 'report_exported',
  REPORT_FILTER_APPLIED: 'report_filter_applied',
  AI_CHAT_OPENED: 'ai_chat_opened',
  AI_CHAT_MESSAGE_SENT: 'ai_chat_message_sent',
  
  // General
  PAGE_VIEWED: 'page_viewed',
  USER_LOGIN: 'user_login',
  USER_LOGOUT: 'user_logout',
} as const;

/**
 * Entity types for better categorization
 */
export const ENTITY_TYPES = {
  PROPERTY: 'property',
  BOOKING: 'booking',
  RESERVATION: 'reservation',
  ANALYSIS: 'analysis',
  REPORT: 'report',
  AI_CHAT: 'ai_chat',
  PAGE: 'page',
  USER: 'user',
  DASHBOARD: 'dashboard',
} as const;
